module.exports = __webpack_public_path__ + "static/media/NoDisponible.bc2e4b13.svg";